import { areFieldsSet } from '@superbet-group/web.lib.utilities';

import { MessageData } from '@core/models/user/pushNotifications/MessageData';

import { MessageDataDto } from './dtos/MessageDataDto';
import { camelCase } from 'lodash';

const MessageDataKeys: Array<keyof MessageDataDto> = [
    'campaign_name',
    'campaign_instance_id',
    'bonus_name',
    'amount',
    'domain',
    'expires',
    'winnings',
    'state_at_expiry',
    'bonus_type',
    'redeemable',
    'title',
    'text',
    'bet',
    'net_win_loss',
    'session_minutes',
    'link',
    'link_text',
    'type',
];

export function transformMessageData(obj: MessageDataDto) {
    return {
        ...Object.fromEntries(
            MessageDataKeys.filter((value: keyof MessageDataDto) =>
                areFieldsSet(obj, value),
            ).map((value) => [camelCase(value), obj[value]]),
        ),
        ...(areFieldsSet(obj, 'expires') && { expirationDate: obj.expires }),
        ...(areFieldsSet(obj, 'state_at_expiry') && { state: obj.state_at_expiry }),
    } as unknown as MessageData;
}
